<template>
  <div
    class="tag"
    :class="`eg-tag-size--${size}`"
    :style="{ cursor: $listeners.click ? 'pointer' : 'default' }"
    :label="tooltip"
    @click="onClickHandler"
  >
    <slot />
    <span class="tag-title text-truncate">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: "TagItem",
  props: {
    label: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: "small",
      validator: (value) => ["small", "medium", "large"].includes(value),
    },
    tooltip: {
      type: String,
      default: null,
    },
  },
  methods: {
    onClickHandler(e) {
      if (!this.$listeners.click) return;

      this.$emit("click", e);
    },
  },
};
</script>

<style scoped lang="scss">
.tag {
  display: inline-flex;
  gap: 4px;
  align-items: center;
  border-radius: 16px;
  border: 1px solid var(--color-stroke-neutral-disabled);
  background-color: var(--color-surface-neutral-container-1);
  color: var(--color-text-neutral-secondary);
  font-weight: var(--typography-font-weight-fw-500);
  transition: all 0.2s ease-in-out;

  .tag-title {
    max-width: 210px;
    line-height: normal;
  }
  &.eg-tag-size {
    &--small {
      height: 22px;
      padding: 4px 6px;
      font-size: var(--typography-font-size-fs-100);
    }
    &--medium {
      height: 24px;
      padding: 4px 8px;
      font-size: var(--typography-font-size-fs-200);
    }
    &--large {
      height: 28px;
      padding: 6px 12px;
      font-size: var(--typography-font-size-fs-300);
    }
  }
}

.tag:hover {
  border-color: #c0c4cc;
  background-color: #f0f0f0;
}
</style>
